import type { IUserMilestone } from '../../IUserMilestone';

/**
 * Set when retailer interacts the ACH PLI offer promo modals and banners *
 */
export const HAS_SEEN_ACH_PROACTIVE_LIMIT_INCREASE_MODAL =
  'HAS_SEEN_ACH_PROACTIVE_LIMIT_INCREASE_MODAL' as IUserMilestone.RetailerMilestone;
